// @flow

type CustommerVehicle = {
  make: string,
  year: number,
  model: string,
  vehicleId?: number,
  metaVehicleId: number,
  mileage?: number,
  engineType?: string,
  engineSize?: string,
  driveType?: string,
  // TODO: handle just one transmission property
  transmissionType?: string,
  transmission?: string,
  trim?: string,
  vin?: string,
  personId?: number,
  // TODO: need to refactor and define where preferredAdvisorId will be declared
  preferredAdvisorId?: number,
  licenseNUmber?: string
};

export const customerVehicleShape = (vehicle: Object): CustommerVehicle => {
  const {
    make,
    year,
    model,
    vehicleId,
    metaVehicleId,
    mileage,
    regDate,
    vehicleRegDate,
    engineType,
    engineSize,
    driveType,
    transmissionType,
    transmission,
    trim,
    vin,
    personId,
    preferredAdvisorId,
    licenseNumber
  } = vehicle;
  return {
    make,
    year,
    model,
    vehicleId,
    metaVehicleId,
    mileage,
    regDate: vehicleRegDate || regDate,
    engineType,
    engineSize,
    driveType,
    transmissionType,
    transmission,
    trim,
    vin,
    personId,
    preferredAdvisorId,
    licenseNumber: licenseNumber ? licenseNumber.toUpperCase() : ''
  };
};



// WEBPACK FOOTER //
// ./src/utils/shape/customerVehicle.js